import { render, staticRenderFns } from "./budget-order-detail.vue?vue&type=template&id=347b26ba"
import script from "./budget-order-detail.vue?vue&type=script&lang=js"
export * from "./budget-order-detail.vue?vue&type=script&lang=js"
import style0 from "./budget-order-detail.vue?vue&type=style&index=0&id=347b26ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports